interface Styles {
  color?: string;
  "font-size"?: string;
  mobile?: {
    "font-size"?: string;
  };
}

interface TextWithStyles {
  icon?: string;
  value?: string;
  styles?: Styles;
}

export interface TextNodeType {
  text?: string | TextWithStyles | TextWithStyles[];
}
